// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2ESbD","unreadBadge":"styles_unreadBadge__22A-J","modalContent":"styles_modalContent__OPHgH","modal":"styles_modal__3vOfJ"};